module.exports = __webpack_public_path__ + "img/材料力学9_4_3.08ca48c3.jpg";